export default {"src":"/_next/static/media/mastercard-logo.caafd6c4.svg","height":144,"width":203,"blurWidth":0,"blurHeight":0};